var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnsplash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "#75808C"
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,8h-3.238c-0.726,0-1.348-0.52-1.476-1.235l-0.201-1.118C19.913,4.693,19.085,4,18.116,4h-6.232 c-0.968,0-1.797,0.693-1.968,1.646L9.715,6.765C9.587,7.48,8.965,8,8.239,8H5c-1.105,0-2,0.895-2,2v13c0,1.105,0.895,2,2,2h20 c1.105,0,2-0.895,2-2V10C27,8.895,26.105,8,25,8z M15,22c-3.314,0-6-2.686-6-6s2.686-6,6-6s6,2.686,6,6S18.314,22,15,22z M15,20 c-2.209,0-4-1.791-4-4s1.791-4,4-4s4,1.791,4,4S17.209,20,15,20z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsplash);
export default __webpack_public_path__ + "static/media/unsplash.75eeb2acf439a391beab7be38f948af4.svg";
export { ForwardRef as ReactComponent };